var Curriculog = Curriculog || {};

Curriculog.IncludeEntityChildrenFilter = (function ($, _, Backbone, IncludeEntityChildrenFilter) {

    IncludeEntityChildrenFilter = Backbone.View.extend({

        id: 'report-9-include-entity-children',

        el: function () {
            return $('#' + this.id);
        },

        events: {},

        initialize: function(options) {
            this.params = options.params;

            this.listenTo(Backbone, 'entity:change', this.changeState);
        },

        get: function() {
            var options = {
                    loading: true,
                    hasChildren: this.$el
                        .parents('.report-search-fields')
                        .find('.entity-types option:selected')
                        .data('children'),
                };

            this.changeState(options);
        },

        set: function() {
            var includeEntityChildren = this.$el.is(':checked') ? parseInt(this.$el.val()) : 0;

            this.params.queryParams.set('includeEntityChildren', includeEntityChildren);
        },

        changeState: function(options) {
            // If the selected value has changed, use that value, otherwise, use the value saved in queryParams
            var includeEntityChildren = this.params.queryParams.get('includeEntityChildren');

            // Set default property states
            this.$el.prop('disabled', false);
            this.$el.prop('checked', false);

            // Change property states if necessary
            if (!options.hasChildren) {
                this.$el.prop('disabled', true);

                // Since we load a bare select input on load and then load the built dropdown after,
                // we run into a race condition that will reset the filter to unchecked(0) if we
                // don't check to see if we are in the initial load state or not
                if (!options.loading) {
                    this.params.queryParams.set('includeEntityChildren', 0);
                }

            } else if (includeEntityChildren) {
                this.$el.prop('checked', true);
            }
        }
    });

    return IncludeEntityChildrenFilter;

})($, _, Backbone, Curriculog.IncludeEntityChildrenFilter || {});